
import './App.css';
import { ThemeProvider, CssBaseline, Box, CircularProgress } from '@mui/material';
import muiTheme from './themes/muiTheme';
import MainFooter from './components/footer/MainFooter';
import { Route, Routes } from 'react-router-dom';


import ScrollToTop from './components/ScrollToTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '@locales/i18n';// import i18n (needs to be bundled ;))
import { MainNabar } from './components/navbar/NavbarWithPopoverOnAccent/MainNabar';
import React, { Suspense } from 'react';
import StickyContactBar from './components/common/StickyContactBar';
import LocalBusinessJsonLd from './components/common/LocalBusinessJsonLd';
import CookieConsentBanner from './components/common/CookieConsentBanner';
import SkipToContent from './components/common/SkipToContent';
import ErrorBoundary from './components/common/ErrorBoundary';
import ServiceWorkerUpdater from './components/common/ServiceWorkerUpdater';
import { LazyMotion, domAnimation } from 'framer-motion';

const HomePage = React.lazy(() => import('./pages/HomePage'));
const CreditRepairPage = React.lazy(() => import('./pages/CreditRepairPage'));
const TaxesPage = React.lazy(() => import('./pages/TaxPage').then((m) => ({ default: m.TaxesPage })));
const TravelPage = React.lazy(() => import('./pages/TravelPage').then((m) => ({ default: m.TravelPage })));
const SupportPage = React.lazy(() => import('@pages/SupportPage').then((m) => ({ default: m.SupportPage })));
const AboutPage = React.lazy(() => import('@pages/AboutPage').then((m) => ({ default: m.AboutPage })));
const UnemploymentPage = React.lazy(() => import('@pages/UnemploymentPage'));
const WorkForcesPage = React.lazy(() => import('@pages/WorkForcesPage'));
const ImmigrationPage = React.lazy(() => import('@pages/ImmigartionPage'));
const InsurancePage = React.lazy(() => import('@pages/InsurancePage').then((m) => ({ default: m.InsurancePage })));
const NotaryPage = React.lazy(() => import('@pages/NotaryPage').then((m) => ({ default: m.NotaryPage })));
const NotFoundPage = React.lazy(() => import('./pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })));

const RouteFallback = () => (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
    </Box>
);

function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <SkipToContent />
      <ToastContainer
        position="top-right"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <ScrollToTop />
      <LocalBusinessJsonLd />
      <MainNabar />
      <Box component="main" id="main-content" tabIndex={-1} sx={{ outline: 'none' }}>
      <ErrorBoundary>
      <LazyMotion features={domAnimation} strict={false}>
      <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/credit_repair' element={<CreditRepairPage />} />
        <Route path='/taxes' element={<TaxesPage />} />
        <Route path='/travel' element={<TravelPage />} />
        <Route path='/support' element={<SupportPage />} />
        <Route path='/about' element={<AboutPage />} />
        <Route path='/qr/:from?' element={<AboutPage />} />
        <Route path='/unemployment' element={<UnemploymentPage />} /> 
        <Route path='/workforce' element={<WorkForcesPage/>} /> 
        <Route path='/immigration' element={<ImmigrationPage />} />
        <Route path='/insurance' element={<InsurancePage />} />
        <Route path='/notary' element={<NotaryPage />} />
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
      </Suspense>
      </LazyMotion>
      </ErrorBoundary>
      </Box>


      <MainFooter />
      <StickyContactBar />
      <CookieConsentBanner />
      <ServiceWorkerUpdater />

    </ThemeProvider>
  );
}

export default App;
